module.exports = __webpack_public_path__ + "static/media/phone_b.193932e0.png";